export default function RotatePhoneSVG() {
  return (
    <svg
      width="89"
      height="147"
      viewBox="0 0 89 147"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="phone-vertical"
    >
      <rect
        x="0.689"
        y="0.562"
        width="87.62"
        height="145"
        rx="11.5"
        stroke="currentColor" //allows CSS to change stroke color
      />
    </svg>
  );
}
